import React, { useEffect, useState, useRef, useContext } from 'react'
import './M_Table.css'
import { useTranslation } from "react-i18next"
import { Accordion, AccordionSummary, AccordionDetails, Badge, InputAdornment, InputBase, Menu, MenuItem, useMediaQuery } from '@mui/material'
import { Search, Close, PushPinOutlined, AddCircleOutlineOutlined, ArrowDownward, CloseRounded } from '@mui/icons-material'
import { DataTable } from 'primereact/datatable/datatable.cjs.js'
import { Column } from 'primereact/column/column.cjs.js'
import { ContextMenu } from 'primereact/contextmenu/contextmenu.cjs.js'
import { Paginator } from 'primereact/paginator/paginator.cjs.js'
import * as XLSX from "xlsx"
import { CrudTable, AdvanceFilter, BufferService, filtersSortService, LoadingBar, LoadingContext, M_SwitchButton, M_Button, M_CheckBox, M_MessageBoard } from '../../M_Components'

export function M_Table({ entityName, useSessionStorage, crud, onPassLine, onPassContext,
    tableHeight, manualId, rolePermissions, lineContext, extraButtons, removeContextItems,
    onHideLabels, toUseFilter, toUseFilterName, selectSingle, refresh, setRefresh,
    isParentTable, isChildTable, setParentLine, parentLine, field, roleName, FILTER,
    replaceFunctions, hasConfirmation, color, secondColor, value, valueIdField }) {
    const ctx = useContext(LoadingContext)
    color = color ? color : ctx.primaryColor ? ctx.primaryColor : "var(--color-black)"
    secondColor = secondColor ? secondColor : ctx.secondaryColor ? ctx.secondaryColor : "var(--color-black)"

    const nameForRole = roleName ? roleName : entityName
    const isSelectSingle = selectSingle !== undefined ? selectSingle : false
    const passFilterName = toUseFilterName ? toUseFilterName : 'Default'
    const passFilter = toUseFilter ? toUseFilter : new Map()
    const removeItem = removeContextItems ? removeContextItems : []
    const newButtons = extraButtons ? extraButtons : []
    const roles = rolePermissions ? rolePermissions : []
    const contextMenu = lineContext ? lineContext : []
    const entity = entityName
    const isPage = useSessionStorage !== undefined ? useSessionStorage : true
    const isCrud = crud !== undefined ? crud : true
    const adjustingTableMedia1 = useMediaQuery('(min-width:1542px)')
    const adjustingTableMedia2 = useMediaQuery('(min-width:1200px)')

    const headerSize = document.body.getElementsByClassName('p-datatable-header')[0]?.offsetHeight || 60
    const paginatorSize = document.body.getElementsByClassName('paginator')[0]?.offsetHeight || 60
    const tabSize = document.body.getElementsByClassName('divTabs')[0]?.offsetHeight || 50
    const tempSize = (document.body.offsetHeight - (headerSize + paginatorSize + tabSize + 3))
    const height = tableHeight ? tableHeight : tempSize

    const { t } = useTranslation()

    const maxWidth = useMediaQuery('(min-width:1050px)')

    const breakAuditWidth = useMediaQuery('(min-width:800px)')
    const breakAuditWidth2 = useMediaQuery('(min-width:500px)')

    const [id, setId] = useState(manualId === undefined ? sessionStorage.getItem('selectedTab') : manualId)

    const [rows, setRows] = useState([])
    const [columns, setColumns] = useState([])

    const [allColumns, setAllColumns] = useState([])

    const [companies, setCompanies] = useState([])

    //* pagination stuff ( not working right )
    const [firstRows, setFirstRows] = useState(0)

    const [page, setPage] = useState(1)
    const [pageSize, setPageSize] = useState(20)
    const [totalRows, setTotalRows] = useState(50)

    //* columns to show up in table
    const [selectedColumns, setSelectedColumns] = useState([])

    //* selected lines
    const [selectedRows, setSelectedRows] = useState(value && [...value] || [])

    //* save line for context menu
    const [selectContext, setSelectContext] = useState(null)

    //* filters and sort
    const [globalFilterValue, setGlobalFilterValue] = useState('')
    const [orderInfo, setOrderInfo] = useState({ columnName: '', orderbool: false })
    const [metaPair, setMetaPair] = useState([])     //*{name:'',type:'',operation:'',value:''}
    const [metaType, setMetaType] = useState([])    //*{metaName:'',metaType:''}
    const [advFilterString, setAdvFilterString] = useState('')
    const [showFilters, setShowFilters] = useState(false)
    const [anchorAF, setAnchorAF] = useState(null)

    //* CRUD STUFF ( not in session storage ( maybe its gonna be changed))

    //* Open/close delete modal
    const [openConfirmDelete, setOpenConfirmDelete] = useState(false)
    //* Map with values from create modal
    const [valueAdd, setValueAdd] = useState(new Map())
    //* object to be edited ( dont know why its an array )
    const [rowEdit, setRowEdit] = useState([])
    //* individual edits saved in a Map
    const [editMap, setEditMap] = useState(new Map())
    //* to change the edit modal to a create with filled values
    const [isCopy, setIsCopy] = useState(false)
    //* sent to crudtable with the line to edit/copy information
    const [row, setRow] = useState(null)
    //* used to defined the type of operation of crud ( create/edit/copy )
    const [operation, setOperation] = useState('')

    //* show/ hide columns
    const [filteredColumnModal, setFilteredColumnModal] = useState([])
    const [valueFilteredColumnModal, setValueFilteredColumnModal] = useState('')
    const [columnContextMenuString, setColumnContextmenuString] = useState({})
    const [anchorEls, setAnchorEls] = useState(null); //* not being sent to session ( its a modal)

    //* Views
    const [anchorV, setAnchorV] = useState(null)
    const [views, setViews] = useState(passFilter)
    const [selectedView, setSelectedView] = useState(passFilterName)

    //* open modal for prints
    const [anchorEl, setAnchorEl] = useState(null); //* not being sent to session ( its a modal)

    const [isFirstLoop, setIsFirstLoop] = useState(true)

    const [isTable, setIsTable] = useState(true)

    const [isLoaded, setIsLoaded] = useState(true)

    const [loading, setLoading] = useState(false)

    const [permissions, setPermissions] = useState([])

    const bufferService = new BufferService(entity)
    const filterService = new filtersSortService()
    const dt = useRef(null)
    const cm = useRef(null)
    const ccm = useRef(null)
    const openMenuPrint = Boolean(anchorEl);
    const openMenuHideColumns = Boolean(anchorEls);
    const openMenuViews = Boolean(anchorV)

    const auditService = new BufferService('audit')
    const [openAudit, setOpenAudit] = useState(false)
    const [auditData, setAuditData] = useState([])

    //*campos do menu de contexto

    const [dataContextMenu, setDataContextMenu] = useState(null)

    const columnContextMenu = [
        {
            label: t("OrderAsc"), icon: (<i className='pi pi-sort-amount-down-alt' style={{ color: color }}></i>), command: () => {
                setOrderInfo({ columnName: columnContextMenuString.target.title, orderbool: false })
                getWithFilters({ columnName: columnContextMenuString.target.title, orderbool: false })
            }
        },
        {
            label: t("OrderDesc"), icon: (<i className='pi pi-sort-amount-up-alt' style={{ color: color }}></i>), command: () => {
                setOrderInfo({ columnName: columnContextMenuString.target.title, orderbool: true })
                getWithFilters({ columnName: columnContextMenuString.target.title, orderbool: true })
            }
        },
        { label: t("Remove"), icon: (<i className="pi pi-times" style={{ color: color }}></i>), command: () => onColumnToggle(getColumnObj(columnContextMenuString.target.title)) },
    ]

    const sessionKeys = ['rows', 'columns', 'selectedColumns', 'globalFilterValue', 'metaPair', 'advFilterString', 'filteredColumnModal', 'valueFilteredColumnModal', 'selectedRows', 'metaType', 'showFilters', 'orderInfo', 'operation', 'isTable', 'rowEdit', 'valueAdd', 'isCopy', 'editMap', 'row', 'totalRows', 'views', 'selectedView', 'pageSize', 'page', 'firstRows', 'companies']

    //*chamada a API dos dados da tabela
    useEffect(() => {
        // debugger
        if (isFirstLoop) {
            setIsLoaded(true)
            getSessionStorageData(id)
            getPermissions()
            setIsFirstLoop(false)

            if (isPage) {
                sessionStorage.setItem(`tab${id}`, JSON.stringify(sessionKeys))
            }
        }
        // eslint-disable-next-line
    }, [])

    const getSeverity = (status) => {
        switch (status) {
            case 'Rejected':
                return '#ff0019';

            case 'Waiting for Approval (Cancel)':
                return '#ba002b';

            case 'Approved':
                return '#00b837';

            case 'Waiting for Approval':
                return '#ffb22e';

            case 'Waiting for Response':
                return '#ffb22e';

            case 'Rejected by Transporter':
                return '#ff0019';

            case 'Waiting for Approval (Changes)':
                return '#ff9130';

            case 'Draft':
                return '#3a71fc';
        }
    }

    const sessionStorageMachine = (id, key, value) => {
        // eslint-disable-next-line
        if (eval(value) instanceof Map) {
            // eslint-disable-next-line
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(Array.from(eval(value))))
        } else {
            // eslint-disable-next-line
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(eval(value)))
        }
    }

    const selectedIncomingValue = (data) => {
        if (value) {
            if (Array.isArray(value)) {
                const tempArray = []
                const newTempArray = []

                //* GET THE REAL OBJECTS FROM THE VALUE ARRAY 
                value.forEach(objValue => {
                    if (valueIdField) {
                        const temp = data.Items.filter(obj => obj[valueIdField] === objValue[valueIdField])
                        if (temp.length) {
                            tempArray.push(temp[0])
                        }
                    } else {
                        const temp = data.Items.filter(obj => obj?.Id === objValue?.Id)
                        if (temp.length) {
                            tempArray.push(temp[0])
                        }
                    }
                })

                if (selectedRows.length) {
                    let newTemp = []

                    selectedRows.forEach(obj => {
                        if (!tempArray.find(tempObj => tempObj.Id === obj.Id)) {
                            newTemp.push(obj)
                        }
                    })
                    newTemp.push(...tempArray)
                    newTempArray.push(...newTemp)

                } else {
                    newTempArray.push(...tempArray)
                }
                setSelectedRows([...newTempArray])
            } else {
                //* GET THE OBJECT VALUE 
                if (valueIdField && value[valueIdField]) {
                    const tempArray = data.Items.filter(obj => obj[valueIdField] === value[valueIdField])
                    setSelectedRows(tempArray)
                } else {
                    if (value?.Id) {
                        const tempArray = data.Items.filter(obj => obj?.Id === value?.Id)
                        setSelectedRows(tempArray)
                    }
                }
            }
        }
    }

    const getSessionStorageData = (sessionID) => {
        if (isPage) {
            const tempRs = sessionStorage.getItem(`${sessionID}rows`)
            const tempC = sessionStorage.getItem(`${sessionID}columns`)
            const tempSC = sessionStorage.getItem(`${sessionID}selectedColumns`)
            const tempGFV = sessionStorage.getItem(`${sessionID}globalFilterValue`)
            const tempMP = sessionStorage.getItem(`${sessionID}metaPair`)
            const tempAFS = sessionStorage.getItem(`${sessionID}advFilterString`)
            const tempFCM = sessionStorage.getItem(`${sessionID}filteredColumnModal`)
            const tempVFCM = sessionStorage.getItem(`${sessionID}valueFilteredColumnModal`)
            const tempMT = sessionStorage.getItem(`${sessionID}metaType`)
            const tempSF = sessionStorage.getItem(`${sessionID}showFilters`)
            const tempOI = sessionStorage.getItem(`${sessionID}orderInfo`)
            const tempO = sessionStorage.getItem(`${sessionID}operation`)
            const tempIT = sessionStorage.getItem(`${sessionID}isTable`)
            const tempRE = sessionStorage.getItem(`${sessionID}rowEdit`)
            const tempVA = sessionStorage.getItem(`${sessionID}valueAdd`)
            const tempIC = sessionStorage.getItem(`${sessionID}isCopy`)
            const tempEM = sessionStorage.getItem(`${sessionID}editMap`)
            const tempR = sessionStorage.getItem(`${sessionID}row`)
            const tempTR = sessionStorage.getItem(`${sessionID}totalRows`)
            const tempV = sessionStorage.getItem(`${sessionID}views`)
            const tempSV = sessionStorage.getItem(`${sessionID}selectedView`)
            const tempPS = sessionStorage.getItem(`${sessionID}pageSize`)
            const tempP = sessionStorage.getItem(`${sessionID}page`)
            const tempFR = sessionStorage.getItem(`${sessionID}firstRows`)
            const tempCnies = sessionStorage.getItem(`${sessionID}companies`)

            if ((tempRs !== "undefined" && tempRs && JSON.parse(tempRs)?.length !== 0 && tempC !== "undefined" && tempC && JSON.parse(tempC)?.length !== 0) && (tempSC || tempGFV || tempMP || tempAFS || tempFCM || tempVFCM || tempMT || tempSF || tempOI || tempO || tempIT || tempRE || tempVA || tempIC || tempEM || tempR || tempTR || tempV || tempSV || tempPS || tempP || tempFR || tempCnies)) {
                setSelectedColumns(JSON.parse(tempSC))
                setGlobalFilterValue(JSON.parse(tempGFV))
                setMetaPair(JSON.parse(tempMP))
                setAdvFilterString(JSON.parse(tempAFS))
                setFilteredColumnModal(JSON.parse(tempFCM))
                setValueFilteredColumnModal(JSON.parse(tempVFCM))
                setRows(JSON.parse(tempRs))
                setColumns(JSON.parse(tempC))
                setMetaType(JSON.parse(tempMT))
                setShowFilters(JSON.parse(tempSF))
                setOrderInfo(JSON.parse(tempOI))
                setOperation(JSON.parse(tempO))
                setIsTable(JSON.parse(tempIT))
                setRowEdit(JSON.parse(tempRE))
                setValueAdd(new Map(JSON.parse(tempVA)))
                setIsCopy(JSON.parse(tempIC))
                setEditMap(new Map(JSON.parse(tempEM)))
                setRow(JSON.parse(tempR))
                setTotalRows(JSON.parse(tempTR))
                setViews(new Map(JSON.parse(tempV)))
                setSelectedView(JSON.parse(tempSV))
                setPageSize(JSON.parse(tempPS))
                setPage(JSON.parse(tempP))
                setFirstRows(JSON.parse(tempFR))
                setCompanies(JSON.parse(tempCnies))
                setIsLoaded(false)
                return
            }
        }
        options()
        setViews(new Map(views.set('Default', '?page=1&pagesize=20')))
    }

    // eslint-disable-next-line
    useEffect(() => {
        if (refresh) {
            setRefresh(false)
            changeView(selectedView)
        }

        if (onHideLabels) onHideLabels(maxWidth)
        if (manualId === undefined) {
            const newId = sessionStorage.getItem('selectedTab')
            if (newId !== id) {
                setId(newId)
                getSessionStorageData(newId)
            }
        }
        else {
            if (manualId !== id) {
                setId(manualId)
                getSessionStorageData(manualId)
            }
        }
    })

    useEffect(() => {
        if (isPage) {
            sessionKeys.forEach((key) => {
                sessionStorageMachine(id, key, key)
            })
        }
        // eslint-disable-next-line
    }, [id, rows, columns, selectedColumns, globalFilterValue, metaPair, advFilterString, filteredColumnModal, valueFilteredColumnModal, selectedRows, metaType, showFilters, orderInfo, operation, isTable, rowEdit, valueAdd, isCopy, editMap, row, totalRows, views, selectedView, pageSize, page, firstRows, companies])

    const options = () => {
        setMetaType([])
        setColumns([])
        setSelectedColumns([])
        setFilteredColumnModal([])
        bufferService.options().then(data => {
            if (data.name === 'AxiosError') {
                toastMessages('error', data.message, '')
                return
            }
            let tempArray = []

            let tempCompanies = JSON.parse(sessionStorage.getItem('companies'))
            if (!tempCompanies || tempCompanies[0].AccountId === null || tempCompanies[0].AccountId === undefined) {
                tempCompanies = []
            }
            setCompanies(tempCompanies)
            data?.forEach((element) => {
                setMetaType(prev => [...prev, {
                    'metaName': element.Name,
                    'metaType': element.Type,
                    'metaDisplay': element.NormalizedName,
                    'metaIsList': element.IsHiddenList,
                    'metaIsEdit': element.IsHiddenEdit,
                    'metaMinLen': element.MinLen,
                    'metaMaxLen': element.MaxLen,
                    'metaIsRequired': element.IsRequired,
                    'metaIsForeignKey': element.IsForeignKey,
                    'metaForeignKeyName': element.ForeignKeyName,
                    'metaForeignTableName': element.ForeignTableName,
                    'metaForeignTableToPassId': element.ForeignTableToPassId,
                    'metaGroupByInfo': element.GroupByInfo
                }])
                // }
                if (element.IsHiddenList) return

                tempArray.push({ ...element, name: element.Name })
                setColumns(prev => [...prev, { ...element, name: element.Name }])
                setSelectedColumns(prev => [...prev, { ...element, name: element.Name }])
                setFilteredColumnModal(prev => [...prev, { ...element, name: element.Name }])
            })
            setAllColumns(tempArray)
            changeView(selectedView)
        })
    }

    const get = (passData) => {
        setRows([])
        if (!isLoaded) setLoading(true)
        const newUrl = filterService.queryBuilder(page, pageSize, undefined, undefined, FILTER)
        bufferService.filter(newUrl).then(data => {
            if (data.name === 'AxiosError') {
                toastMessages('error', data.message, '')
                setRows([])
                setTotalRows([])
                setIsLoaded(false)
                setLoading(false)
                return
            }

            selectedIncomingValue(data)

            setTotalRows(data.TotalItems)
            setRows(data.Items)
            setIsLoaded(false)
            setLoading(false)
        })
    }

    // eslint-disable-next-line
    const deRetardationString = (data) => {
        return data.replace(/([A-Z])/g, ' $1').trim();
    }

    const getType = (input) => {
        if (input === 'true' || input === 'false') {
            return 'boolean';
        } else if (/^-?\d+$/.test(input)) {
            return 'int32';
        } else {
            return 'string';
        }
    }

    const getValue = (input) => {
        if (input === 'true') {
            return true;
        } else if (input === 'false') {
            return false;
        } else if (/^-?\d+$/.test(input)) {
            return parseInt(input);
        } else if (/^-?\d*\.\d+$/.test(input)) {
            return parseFloat(input);
        } else {
            return input;
        }
    }

    const getPermissions = () => {
        roles.forEach((role) => {
            if (role.match(nameForRole)) {
                const tempPerm = role.split(nameForRole)[1]
                setPermissions(prev => [...prev, tempPerm])
            }
        })
    }

    const saveFilter = (newView) => {
        setLoading(true)
        let url = filterService.advancedSearch(metaPair, true)
        setAdvFilterString(url)
        if (orderInfo.columnName) {
            url = filterService.orderBy(orderInfo, url)
        }
        const tempPageString = filterService.pagination(page, pageSize)
        url = tempPageString.concat(url)

        const newUrl = filterService.queryBuilder(page, pageSize, orderInfo, metaPair, FILTER)

        bufferService.filter(newUrl).then(res => {
            if (res.name === 'AxiosError') {
                toastMessages('error', res.message, '')
                setRows([])
                setTotalRows([])
                setLoading(false)
                setIsLoaded(false)
                return
            }

            selectedIncomingValue(res)

            setTotalRows(res.TotalItems)
            setRows(res.Items)
            setLoading(false)
            setIsLoaded(false)
        })

        setViews(new Map(views.set(newView, url)))
        setSelectedView(newView)
    }

    const changeView = (viewName) => {
        if (!isLoaded) setLoading(true)
        setAdvFilterString('')
        setMetaPair([])
        setOrderInfo({ columnName: '', orderbool: false })
        setSelectedView(viewName)
        const url = views.get(viewName)
        let objectFilterArray = []
        let objectOrderBy = { columnName: '', orderbool: false }
        if (url === undefined) {
            get()
            return
        }
        url.split('&').forEach((elem) => {
            if (elem.includes("filter")) {
                setAdvFilterString('&' + elem)
                let stringFilter = elem.split('filter=')[1]
                stringFilter = stringFilter.split(' and ')
                stringFilter.forEach((el) => {
                    const tempArray = el.split(' ')
                    let tempObj
                    let tempOp = ''
                    if (tempArray[0] == '') tempArray.shift()

                    tempObj = metaType.filter(meta => meta.metaName === tempArray[0])
                    if (tempArray[1] === 'eq') {
                        if (tempArray[1] === 'eq' && tempArray[2].includes('$')) {
                            tempOp = 'Contains'
                        } else {
                            tempOp = 'Equals'
                        }
                    }
                    if (tempArray[1] === 'Greater') tempOp = 'Greater'
                    let objectFilter
                    if (tempObj.length) {
                        objectFilter = {
                            name: tempArray[0],
                            display: tempObj[0].metaDisplay,
                            type: tempObj[0].metaType,
                            operation: tempOp,
                            value: tempArray[2].replaceAll("'", '').replaceAll("$", '')
                        }
                    } else {
                        if (tempArray[0].includes('contains')) {

                            tempOp = 'Contains'
                            objectFilter = {
                                name: tempArray[0].split(',')[0].replace('contains(', ''),
                                display: deRetardationString(tempArray[0].split(',')[0].replace('contains(', '')),
                                type: 'string',
                                operation: tempOp,
                                value: decodeURIComponent(tempArray[0]).split(',')[1].replace(')', '').replaceAll("'", '')
                            }
                        } else {
                            objectFilter = {
                                name: tempArray[0],
                                display: deRetardationString(tempArray[0]),
                                type: getType(tempArray[2].replaceAll("'", '').replaceAll("$", '')),
                                operation: tempOp,
                                value: getValue(tempArray[2].replaceAll("'", '').replaceAll("$", ''))
                            }
                        }
                    }
                    objectFilterArray.push(objectFilter)
                    // setMetaPair(prev => [...prev, objectFilter])

                })
            }
            if (elem.includes('order')) {
                let stringOrder = elem.split('orderby=')[1]
                stringOrder = stringOrder.split(' ')
                let tempBool = ''
                if (stringOrder[1] === 'asc') tempBool = false
                if (stringOrder[1] === 'desc') tempBool = true
                objectOrderBy = { columnName: stringOrder[0].toUpperCase(), orderbool: tempBool }
                // setOrderInfo(objectOrderBy)

            }
        })
        setMetaPair(objectFilterArray)
        setOrderInfo(objectOrderBy)

        const newUrl = filterService.queryBuilder(page, pageSize, objectOrderBy, objectFilterArray, FILTER)

        bufferService.filter(newUrl).then(res => {
            if (res.name === 'AxiosError') {
                toastMessages('error', res.message, '')
                setRows([])
                setTotalRows([])
                setLoading(false)
                setIsLoaded(false)
                return
            }

            selectedIncomingValue(res)

            setTotalRows(res.TotalItems)
            setRows(res.Items)
            setLoading(false)
            setIsLoaded(false)
        })
    }

    const deleteView = (name) => {
        views.delete(name)
        setViews(new Map(views))
        if (selectedView === name) {
            setSelectedView('')
        }
    }

    const createView = (e) => {
        get(allColumns)
        setMetaPair([])
        setSelectedView('')
        handleClickCloseViews()
        setAnchorAF(document.getElementById('advFilter'))
    }

    const getWithFilters = (ord, newPage, newRows, adv) => {
        setLoading(true)
        const customPage = newPage ? newPage : page
        const customPageSize = newRows ? newRows : pageSize
        const customOrder = ord ? ord : orderInfo
        const customAdv = adv ? adv : metaPair

        let url = filterService.queryBuilder(customPage, customPageSize, customOrder, customAdv, FILTER)

        bufferService.filter(url).then(res => {
            if (res.name === 'AxiosError') {
                toastMessages('error', res.message, '')
                setRows([])
                setTotalRows([])
                setLoading(false)
                setIsLoaded(false)
                return
            }

            selectedIncomingValue(res)

            setTotalRows(res.TotalItems)
            setRows(res.Items)
            setLoading(false)
            setIsLoaded(false)
        })
    }

    const addMetaPair = (filter) => {
        let tempBol = false
        if (metaPair.length) {
            metaPair.forEach((element) => {
                //* checking if it exists
                if (element.name === filter.name) {
                    tempBol = true
                }
            })
            if (tempBol === true) {
                //* editing if it already exists
                setMetaPair(metaPair.map((elem) => elem.name === filter.name ? { ...elem, operation: filter.operation, value: filter.value } : elem))
            }
            else {
                //* creating new if it doesnt exist
                setMetaPair(prev => [...prev, filter])
            }
        }
        else {
            //* creating if array empty
            setMetaPair([filter])
        }
    }

    //*submit filters
    const submitFilters = (input, order) => {
        setLoading(true)
        const data = input ? input : metaPair
        const passOrder = order ? order : orderInfo

        let url = filterService.queryBuilder(page, pageSize, passOrder, data, FILTER)

        bufferService.filter(url).then(res => {
            if (res.name === 'AxiosError') {
                toastMessages('error', res.message, '')
                setRows([])
                setTotalRows([])
                setLoading(false)
                setIsLoaded(false)
                return
            }

            selectedIncomingValue(res)

            setTotalRows(res.TotalItems)
            setRows(res.Items)
            setLoading(false)
            setIsLoaded(false)
        })
        return url
    }

    //*clear all advanced filters
    const deleteAllFilters = () => {
        setLoading(true)
        setAdvFilterString('')
        setMetaPair([])
        const newUrl = filterService.queryBuilder(page, pageSize, orderInfo, undefined, FILTER)

        bufferService.filter(newUrl).then(res => {
            if (res.name === 'AxiosError') {
                toastMessages('error', res.message, '')
                setRows([])
                setTotalRows([])
                setLoading(false)
                setIsLoaded(false)
                return
            }

            selectedIncomingValue(res)

            setTotalRows(res.TotalItems)
            setRows(res.Items)
            setLoading(false)
            setIsLoaded(false)
        })

    }

    //*delete advanced filters individually
    const deleteFilter = (filterName) => {
        const tempMeta = metaPair.filter(elem => elem.name !== filterName)
        setMetaPair(tempMeta)
        submitFilters(tempMeta)
    }

    //*sort the columns
    const order = (e) => {
        if (e.target.id === 'columnTable') {
            setLoading(true)
            const column = e.target.title
            let newOrderInfo = {}
            if (orderInfo.columnName === column) {
                if (orderInfo.orderbool === false) {
                    const resetOrder = { columnName: '', orderbool: false }
                    setOrderInfo(resetOrder)
                    getWithFilters(resetOrder)  //* advFilterString ? metaPair.length ? submitFilters() : globalFilter() : get()
                    return
                }
                newOrderInfo = { columnName: column, orderbool: !orderInfo.orderbool }
            } else {
                newOrderInfo = { columnName: column, orderbool: true }
            }
            setOrderInfo(newOrderInfo)
            let url = filterService.orderBy(newOrderInfo, advFilterString)
            const tempPageString = filterService.pagination(page, pageSize)
            url = tempPageString.concat(url)
            let newUrl = filterService.queryBuilder(page, pageSize, newOrderInfo, metaPair, FILTER)
            // setOrderString(url)
            bufferService.filter(newUrl).then(res => {
                if (res.name === 'AxiosError') {
                    toastMessages('error', res.message, '')
                    setRows([])
                    setTotalRows([])
                    setLoading(false)
                    setIsLoaded(false)
                    return
                }

                selectedIncomingValue(res)

                setTotalRows(res.TotalItems)
                setRows(res.Items)
                setLoading(false)
                setIsLoaded(false)
            })
        }
    }

    //*table refresh / was refresh of all filters and sort
    const clear = () => {
        getWithFilters()
        toastMessages('success', '', t("RefreshTable"))
    }

    const getColumnObj = (header) => {
        const tempArray = columns.filter(obj => obj.Header === header)
        return tempArray[0]
    }

    //*show and hide table columns
    const onColumnToggle = (data, event) => {
        let tempArray = []
        if (selectedColumns.find((element) => element.Name === data.name)) {
            tempArray = selectedColumns.filter(el => el.Name !== data.name)
            setSelectedColumns(tempArray)
            return
        } else {
            setSelectedColumns(prev => [...prev, data])
            return
        }
    }
    const isColumnChecked = (data) => {
        if (selectedColumns.find((element) => element.name === data)) {
            return true
        } else {
            return false
        }
    }

    //* search on show/hide columns
    const filterColumnModal = (data) => {
        setValueFilteredColumnModal(data)
        const regex = new RegExp(data)
        const tempElem = columns.filter((elem) => regex.test(elem.name))
        setFilteredColumnModal(tempElem)
    }

    //*open delete confirmation modal
    const handleOpenDelete = (line) => {
        // const tempLine = JSON.parse(sessionStorage.getItem('contextLine'))
        // sessionStorage.removeItem('contextLine')
        // if (tempLine && Object.keys(tempLine).length) {
        //     setOpenConfirmDelete(true)
        //     return
        // }
        // if (selectedRows.length !== 0) {
        //     setOpenConfirmDelete(true)
        // } else {
        //     toastMessages('error', '', t("SelectedLine"))
        // }
        if (Array.isArray(line) && line.length > 0) {
            //DELETE BY SELECTING LINES
            setDataContextMenu(null)
            setOpenConfirmDelete(true)
        } else if (line && typeof line === 'object' && Object.keys(line).length > 0) {
            //DELETE BY CONTEXT MENU
            setDataContextMenu(line)
            setOpenConfirmDelete(true)
        } else {
            toastMessages('error', '', t("SelectedLine"))
        }
    }
    //*close delete confirmation modal
    const handleCloseConfirmDelete = () => {
        setDataContextMenu(null)
        setOpenConfirmDelete(false);
    }

    //*open add row to table page
    const handleOpenDialogAdd = () => {
        setOperation('Create')
        setRow(null)
        setIsTable(false)
    }

    //*open copy row from table page
    const handleOpenCopy = (selected) => {
        // const tempLine = JSON.parse(sessionStorage.getItem('contextLine'))
        // sessionStorage.removeItem('contextItem')
        const row = selected ? selected : null

        if (row) {
            setIsCopy(true)
            setRow(row)
            setOperation('Copy')
            setIsTable(false)
        }
        else {
            setIsTable(true)
            toastMessages('error', '', t("SelectedLine"))
        }
    }

    //*open edit row from table page
    const handleOpenEdit = (selected) => {
        // const tempLine = JSON.parse(sessionStorage.getItem('contextLine'))
        // sessionStorage.removeItem('contextItem')
        const row = selected ? selected : null
        if (row) {
            setRow(row)
            setOperation('Edit')
            setIsTable(false)
        }
        else {
            setIsTable(true)
            toastMessages('error', '', t("SelectedLine"))
        }
    }

    //* open view row from table page
    const handleView = (selected) => {
        // const tempLine = JSON.parse(sessionStorage.getItem('contextLine'))
        // sessionStorage.removeItem('contextItem')
        const row = selected ? selected : null
        if (row) {
            setRow(row)
            setOperation('View')
            setIsTable(false)
        }
        else {
            setIsTable(true)
            toastMessages('error', '', t("SelectedLine"))
        }
    }

    const onlyVisibleItems = (lineArray) => {
        const dict = new Map()
        const objectArray = []
        lineArray.forEach(element => {
            let tempBol = false
            Object.entries(element).forEach(keyValue => {
                tempBol = false
                selectedColumns.forEach(header => {
                    if (header.Name === keyValue[0]) tempBol = true
                })
                if (tempBol) dict.set(keyValue[0], keyValue[1])
            })
            objectArray.push(Object.fromEntries(dict))
        })

        return objectArray
    }

    const nextChar = (char) => {
        return String.fromCharCode(char.charCodeAt(0) + 1)
    }

    //* Export Excel
    const exportExcel = () => {
        const tempRows = selectedRows.length ? onlyVisibleItems(selectedRows) : onlyVisibleItems(rows)
        var wb = XLSX.utils.book_new(),
            ws = XLSX.utils.json_to_sheet(tempRows)
        XLSX.utils.book_append_sheet(wb, ws, entity)
        XLSX.writeFile(wb, `${entity}.xlsx`)
        handleCloseMenuPrint()
        toastMessages('success', '', t("ExportSuccess"))
    }

    const importExcel = (e) => {
        const file = e.target.files[0]
        const importArray = []
        file.arrayBuffer().then(el => {

            const workbook = XLSX.read(el)
            const sheetName = workbook.SheetNames
            const sheet = workbook.Sheets[sheetName]
            const sheetRange = sheet['!ref']

            const regexstart = new RegExp('([A-Z])')

            const sheetRangeSplit = sheetRange.split(':')
            const sheetRangeStartSplit = sheetRangeSplit[0].split(regexstart)
            const sheetColStart = sheetRangeStartSplit[1]
            const sheetRowStart = sheetRangeStartSplit[2]

            const sheetRangeEndSplit = sheetRangeSplit[1].split(regexstart)
            const sheetColEnd = sheetRangeEndSplit[1]
            const sheetRowEnd = sheetRangeEndSplit[2]

            for (let e = nextChar(sheetRowStart); e <= sheetRowEnd; e++) {
                const tempDict = new Map()
                for (let i = sheetColStart; i !== nextChar(sheetColEnd); i = nextChar(i)) {
                    if (sheet[i + e]) {
                        tempDict.set(sheet[i + 1].v, sheet[i + e].v)
                        continue
                    }
                    tempDict.set(sheet[i + 1].v, '')
                }
                importArray.push(Object.fromEntries(tempDict))
            }
            importArray.forEach((element) => {
                post(element).then(data => {
                    if (data.name === 'AxiosError') {
                        toastMessages('error', data.response.data.errors, t("Error"))
                        return
                    }
                    toastMessages('success', '', t("AddSuccess"))
                    getWithFilters()
                })
            })
        })
        handleCloseMenuPrint()
    }

    //* table row selection
    const onSelectionChange = (e) => {
        let tempValue = []

        if (isSelectSingle) {
            tempValue = [e.value]
        } else {
            if (e.type === 'all') {
                if (e.value.length) {
                    selectedRows.forEach(obj => {
                        if (!e.value.find(rowObj => rowObj.Id === obj.Id)) {
                            tempValue.push(obj)
                        }
                    })
                    tempValue.push(...e.value)
                } else {
                    selectedRows.forEach(obj => {
                        if (!rows.find(rowObj => rowObj.Id === obj.Id)) {
                            tempValue.push(obj)
                        }
                    })
                }
            } else {
                tempValue = [...e.value]
            }
        }

        if (isParentTable) {
            setParentLine(tempValue)
            onPassLine(tempValue)
        }
        if (onPassLine) {
            onPassLine(tempValue)
        }
        setSelectedRows([...tempValue])
    }

    const post = async (data) => {

        setLoading(true)

        const res = await bufferService.post(data).then(response => {
            setLoading(false)
            return response
        })
        const dataRes = await res
        return dataRes
    }

    const postDelete = () => {
        // let tempArray = []
        // if (selectedRows.length) {
        //     tempArray = selectedRows
        // } else {
        //     const tempLine = JSON.parse(sessionStorage.getItem('contextLine'))
        //     tempArray.push(tempLine)
        // }
        // let tempBOL = false
        // tempArray.forEach((elem) => {
        //     deleteCall(elem.Id).then(data => {
        //         if (data.name === 'AxiosError') {
        //             if (data?.response?.data) {
        //                 toastMessages('error', data.response.data,)
        //                 setOpenConfirmDelete(false)
        //             } else {
        //                 toastMessages('error', data.response.data.errors, t("SelectedMultiLine"))
        //             }
        //         } else {
        //             tempBOL = true
        //             toastMessages('success', '', t("RemoveLine"))
        //             setOpenConfirmDelete(false)
        //         }
        //     })
        // })
        // setTimeout(() => {
        //     if (tempBOL === true) {
        //         getWithFilters()
        //     }
        // }, 500)
        let tempArray = []
        if (dataContextMenu) {
            //* DELETE BY CONTEXT MENU
            bufferService.delete(dataContextMenu.Id).then(data => {
                if (data.name === 'AxiosError') {
                    if (data?.response?.data) {
                        toastMessages('error', data.response.data,)
                        setOpenConfirmDelete(false)
                    } else {
                        toastMessages('error', data.response.data.errors, t("SelectedMultiLine"))
                    }
                } else {
                    setDataContextMenu(null)
                    toastMessages('success', '', t("RemoveLine"))
                    setOpenConfirmDelete(false)
                    getWithFilters()
                }
            })
        } else {
            //* DELETE BY SELECTING LINES
            if (selectedRows.length) {
                tempArray = selectedRows
            }
        }
        tempArray.forEach((elem) => {
            console.log(elem.Id)
            bufferService.delete(elem.Id).then(data => {
                if (data.name === 'AxiosError') {
                    console.log("dddddd", data)
                    toastMessages('error', data.response.data, '')
                } else {
                    setSelectedRows(null)
                    toastMessages('success', '', t("RemoveLine"))
                    setOpenConfirmDelete(false)
                    getWithFilters()
                }
            })
        })
    }

    const onPage = (event) => {
        setFirstRows(event.first)
        const newPage = event.page + 1
        setPage(newPage)
        setPageSize(event.rows)
        //* send to filter to create query and attach to string
        getWithFilters('', newPage, event.rows)
    }

    const rightClick = (e) => {
        if (e.target.id !== "columnTable") return
        setColumnContextmenuString(e)
        ccm.current.show(e)
    }

    //*open export menu
    const handleClickOpenMenuPrint = (event) => {
        setAnchorEl(event.currentTarget)
    }

    //*close export menu
    const handleCloseMenuPrint = () => {
        setAnchorEl(null);
    }

    //*open menu show hide
    const handleClickOpenMenuHideColumns = (event) => {
        setAnchorEls(event.currentTarget)
    }

    //*close menu show/hide
    const handleCloseMenuHideColumns = () => {
        setAnchorEls(null)
    }

    const handleClickOpenViews = (event) => {
        setAnchorV(event.currentTarget)
    }

    const handleClickCloseViews = () => {
        setAnchorV(null)
    }

    const handleOpenAdvancedFilterMenu = (event) => {
        setAnchorAF(event.currentTarget)
    }

    //*Toast Messages
    const toastMessages = (type, alert, string) => {
        ctx.toastMessages(type, alert, string)
    }

    const extraButtonFunction = (data, func, need) => {
        const tempNeed = need !== null ? need : true
        if (data === undefined && tempNeed) {
            toastMessages('error', '', t("SelectedLine"))
            return
        }
        sessionStorage.setItem('contextLine', JSON.stringify(data))
        if (value) {

            // const tempObj1 = selectedRows.filter(obj => )
            func(selectedRows)
        } else {
            func(data)
        }
    }

    //*header table
    const header = (
        <div className="display header">
            <div className="menuIcon">
                <M_Button
                    tooltip={t("RefreshTable")}
                    label={t("RefreshTable")}
                    icon={<i className='pi pi-refresh'></i>}
                    onClick={() => clear()}
                />
                {isCrud ? (
                    <>
                        {!removeItem.includes('Print') &&
                            <M_Button
                                tooltip={t("Print")}
                                label={t("Print")}
                                icon={<i className='pi pi-print'></i>}
                                onClick={handleClickOpenMenuPrint}
                            />
                        }
                        <Menu
                            anchorEl={anchorEl}
                            open={openMenuPrint}
                            onClose={handleCloseMenuPrint}
                            className="menuExcel"
                        >
                            {permissions.includes('Create') && !removeItem.includes('Create') &&
                                <MenuItem className='menuItem'>
                                    <input
                                        className='importExcel'
                                        type="file"
                                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                        onChange={importExcel}
                                    />
                                    {t("ImportExcel")}
                                </MenuItem>
                            }
                            <MenuItem className='menuItem' onClick={exportExcel}>
                                {t("ExportExcel")}
                            </MenuItem>
                        </Menu>
                        {permissions.includes('Create') && !removeItem.includes('Create') &&
                            <M_Button
                                tooltip={t("Add")}
                                label={t("Add")}
                                icon={<AddCircleOutlineOutlined style={{ color: 'var(--color-green-light)' }} />}
                                onClick={replaceFunctions?.get('Create') ? () => replaceFunctions?.get('Create')() : () => handleOpenDialogAdd()}
                            />
                        }
                        {permissions.includes('Edit') && !removeItem.includes('Edit') &&
                            <M_Button
                                tooltip={t("Edit")}
                                label={t("Edit")}
                                icon={<i className='pi pi-pencil iconTable'></i>}
                                onClick={replaceFunctions?.get('Edit') ? () => replaceFunctions?.get('Edit')(selectedRows[selectedRows.length - 1]) : () => handleOpenEdit(selectedRows.pop())}
                            />
                        }
                        {permissions.includes('Delete') && !removeItem.includes('Delete') &&
                            <M_Button
                                tooltip={t("Delete")}
                                label={t("Delete")}
                                icon={<i className='pi pi-trash iconTable'></i>}
                                onClick={replaceFunctions?.get('Delete') ? () => replaceFunctions?.get('Delete')(selectedRows) : () => handleOpenDelete(selectedRows)}
                            />
                        }
                        {permissions.includes('Create') && !removeItem.includes('Copy') &&
                            <M_Button
                                tooltip={t("Copy")}
                                label={t("Copy")}
                                icon={<i className='pi pi-copy iconTable'></i>}
                                onClick={replaceFunctions?.get('Copy') ? () => replaceFunctions?.get('Copy')(selectedRows[selectedRows.length - 1]) : () => handleOpenCopy(selectedRows.pop())}
                            />
                        }
                    </>
                ) : ''}
                {newButtons.map((btn, index) =>
                    btn.element === 'default' ?
                        <React.Fragment key={index}>
                            <M_Button
                                tooltip={btn.label}
                                label={btn.label}
                                icon={btn?.icon ? btn?.icon : <img style={btn.style} src={btn.source} alt={btn.label} className="iconTable" />}
                                onClick={() => extraButtonFunction(selectedRows[selectedRows.length - 1], btn.command, btn?.needLine)}
                            />
                            {btn.extraEl !== null ?
                                btn.extraEl
                                : ''}
                        </React.Fragment>
                        : btn.element
                )}
                {/* {isCrud && permissions.includes('Audit') && !removeItem.includes('Audit') &&
                    <M_Button
                        tooltip={t("Audit")}
                        label={t("Audit")}
                        icon={<i className='pi pi-search iconTable'></i>}
                        onClick={replaceFunctions?.get('Audit') ? replaceFunctions?.get('Audit') : () => getAudit(selectedRows.pop())}
                    />} */}
            </div>
            <div className="menuSearch">
                {selectedView}
                <M_Button
                    tooltip={t("Views")}
                    label={t("Views")}
                    icon={<PushPinOutlined style={{ transform: 'rotate(45deg)' }} />}
                    onClick={handleClickOpenViews}
                />
                <M_Button
                    id={'advFilter'}
                    tooltip={t("Filters")}
                    label={t("Filters")}
                    icon={
                        <Badge anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                            badgeContent={metaPair.length}
                            sx={{
                                "& .MuiBadge-badge": {
                                    color: "var(--color-white)",
                                    backgroundColor: `${color ? color : "var(--color-black)"}`
                                }
                            }} >
                            <i className='pi pi-filter'></i>
                        </Badge>
                    }
                    onClick={handleOpenAdvancedFilterMenu}
                />
                <M_Button
                    tooltip={t("editColumns")}
                    label={t("editColumns")}
                    icon={<i className='pi pi-eye'></i>}
                    onClick={handleClickOpenMenuHideColumns}
                />
                <Menu
                    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                    transformOrigin={{ vertical: "top", horizontal: "center" }}
                    anchorEl={anchorEls}
                    open={openMenuHideColumns}
                    onClose={handleCloseMenuHideColumns}
                    className="organizeMenuSearchTable"
                    MenuListProps={{ disablePadding: true }}
                >
                    <div className='stickyTopTable'>
                        <MenuItem disableRipple={true} className="organizeMenuItem" >
                            <InputBase
                                onChange={(e) => { filterColumnModal(e.target.value) }}
                                placeholder={t("Search")}
                                className='organizeInputBase'
                                inputProps={{ 'aria-label': 'Search Columns' }}
                                value={valueFilteredColumnModal}
                                startAdornment={
                                    <InputAdornment position="start"> <Search /> </InputAdornment>
                                }
                            />
                        </MenuItem>
                    </div>
                    {filteredColumnModal.map((col, index) => (
                        <div className='menuSwtchs menuItem' key={index}>
                            <M_SwitchButton label={col.NormalizedName} color={color ? color : "var(--color-black)"} checked={isColumnChecked(col.name)} onClick={(event) => onColumnToggle(col, event)} />
                        </div>
                    ))}
                </Menu>
                <Menu
                    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                    transformOrigin={{ vertical: "top", horizontal: "center" }}
                    anchorEl={anchorV}
                    open={openMenuViews}
                    onClose={handleClickCloseViews}
                    className="menuViews"
                    MenuListProps={{ disablePadding: true }}
                >
                    <div className='stickyTop center'>
                        <MenuItem disableRipple={true} className="cursorDefault viewsLabel" >
                            {t("Views")}
                        </MenuItem>
                    </div>
                    <div className='midleViews menuitem'>
                        <div className='viewsMasterDiv'>
                            <div
                                style={selectedView === 'Default' ?
                                    { border: `1px solid ${color ? color : "var(--color-black)"}`, backgroundColor: `${color ? color : "var(--color-black)"}` } :
                                    { border: '1px solid var(--color-grey-light)', backgroundColor: 'transparent' }}
                                className={selectedView === 'Default' ? 'defaultViewdiv' : 'defaultUnselectedViewDiv'}
                                onClick={() => { changeView('Default') }}
                            >
                                <span className={selectedView === 'Default' ? 'spanSelectedView' : 'unselectSpanView'}> Default </span>
                            </div>
                        </div>
                    </div>
                    {Object.keys(Object.fromEntries(views)).map((col, index) => (
                        <div className='midleViews menuitem' key={index}>
                            {col !== 'Default' ?
                                <div className='viewsMasterDiv'>
                                    <div
                                        style={selectedView === col ?
                                            { border: `1px solid ${color ? color : "var(--color-black)"}`, backgroundColor: `${color ? color : "var(--color-black)"}` } :
                                            { border: '1px solid var(--color-grey-light)' }}
                                        className={selectedView === col ? 'selectedViewsDiv' : 'unselectViewSpan'}
                                        onClick={() => { changeView(col) }}
                                    >
                                        <span className={selectedView === col ? 'spanSelectedView' : 'unselectSpanView'}> {col} </span>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <M_Button hoverEffect none icon={<Close />} onClick={() => deleteView(col)} borderColor={selectedView === col ? `${color ? color : "var(--color-black)"}` : 'var(--color-grey-light)'} />
                                    </div>
                                </div>
                                : ''
                            }
                        </div>
                    ))}
                    <div className='stickyBot center' style={{ marginBottom: '5px' }} >
                        <M_Button
                            icon={<i className="pi pi-plus-circle" style={{ fontSize: '1rem', color: 'var(--color-white)' }}></i>}
                            hoverEffect
                            backgroundColor={'var(--color-green)'}
                            labelColor={'var(--color-white)'}
                            onClick={(e) => createView(e)}
                            label={`${t('CreateNewView')}`}
                            width={25}
                        />
                    </div>
                </Menu>
            </div>
            <div>
                <AdvanceFilter
                    color={color ? color : "var(--color-black)"}
                    onDeleteFilter={deleteFilter}
                    onDeleteAllFilters={deleteAllFilters}
                    onSubmitFilters={submitFilters}
                    onAddMetaPair={addMetaPair}
                    metaPair={metaPair}
                    metaType={metaType}
                    showFilters={showFilters}
                    anchorAF={anchorAF}
                    setAnchorAF={setAnchorAF}
                    onSaveFilter={saveFilter}
                    selectedView={selectedView}
                    views={views}
                    onToasts={(type, alert, string) => toastMessages(type, alert, string)}
                />
            </div>
        </div >
    )

    // === Adicionar: componente recursivo para AuditFields ===
    const RenderAuditFields = ({ fields, depth = 0 }) => {
        if (!Array.isArray(fields) || fields.length === 0) return null;

        return fields.map((f, i) => {
            const key = f?.Id || `${depth}-${i}-${f?.Field || 'field'}`;
            const hasChildren = Array.isArray(f?.FieldsList) && f.FieldsList.length > 0;

            if (hasChildren) {
                // Item com filhos -> Accordion para poder expandir
                return (
                    <Accordion
                        key={key}
                        sx={{
                            border: '1px dashed var(--color-grey-dark)',
                            borderRadius: '8px',
                            mb: 1,
                            ml: `${depth * 12}px`
                        }}
                    >
                        <AccordionSummary expandIcon={<ArrowDownward />}>
                            <div style={{ display: 'grid', gridTemplateColumns: !breakAuditWidth ? 'auto' : '33% 33% 33%', width: '100%' }}>
                                <div><strong>{t("Field")}:</strong> {f.Field}</div>
                                <div><strong>{t("OldValue")}:</strong> {f.OldValue ?? 'null'}</div>
                                <div><strong>{t("NewValue")}:</strong> {f.NewValue ?? 'null'}</div>
                            </div>
                        </AccordionSummary>

                        <AccordionDetails sx={{ backgroundColor: i % 2 ? 'var(--color-grey-light)' : 'transparent' }}>
                            {/* recursão para o próximo nível */}
                            <RenderAuditFields fields={f.FieldsList} depth={depth + 1} />
                        </AccordionDetails>
                    </Accordion>
                );
            }

            // Item sem filhos -> linha simples (mantém estilo anterior)
            return (
                <AccordionDetails
                    key={key}
                    sx={{
                        backgroundColor: i % 2 ? 'var(--color-grey-light)' : 'transparent',
                        borderBottomLeftRadius: (i + 1 === fields.length) ? '10px' : undefined,
                        borderBottomRightRadius: (i + 1 === fields.length) ? '10px' : undefined
                    }}
                >
                    <div style={{ color: 'var(--color-black)', display: 'grid', gridTemplateColumns: !breakAuditWidth ? 'auto' : '33% 33% 33%' }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{ fontSize: '12px', marginRight: '10px' }}>{t("Field")}:</div>
                            <div style={{ userSelect: 'all', fontWeight: 'bold', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'wrap' }}>{f.Field}</div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{ fontSize: '12px', marginRight: '10px' }}>{t("OldValue")}:</div>
                            <div style={{ userSelect: 'all', fontWeight: 'bold', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'wrap' }}>{f.OldValue ?? 'null'}</div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{ fontSize: '12px', marginRight: '10px' }}>{t("NewValue")}:</div>
                            <div style={{ userSelect: 'all', fontWeight: 'bold', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'wrap' }}>{f.NewValue ?? 'null'}</div>
                        </div>
                    </div>
                </AccordionDetails>
            );
        });
    };


    const getAudit = (line) => {
        if (!line) {
            ctx.toastMessages('error', '', t("SelectedLine"))
        }

        if (line?.IdBooking) {
            ctx.setIsLoad(true)
            auditService.getId(line?.IdBooking).then(resAudit => {
                if (Array.isArray(resAudit)) {
                    setAuditData(resAudit)
                    setOpenAudit(true)
                    ctx.setIsLoad(false)
                } else {
                    ctx.toastMessages('error', '', t("noAudit"))
                    ctx.setIsLoad(false)
                }

            })
        } else {
            ctx.setIsLoad(true)
            auditService.getId(line?.Id).then(resAudit => {
                if (Array.isArray(resAudit)) {
                    setAuditData(resAudit)
                    setOpenAudit(true)
                    ctx.setIsLoad(false)
                } else {
                    ctx.toastMessages('error', '', t("noAudit"))
                    ctx.setIsLoad(false)
                }

            })
        }
    }

    const closeAudit = () => {
        setOpenAudit(false)
        setAuditData([])
    }

    const verifiedBodyTemplate = (rowData, field) => {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <M_CheckBox disabled checked={rowData[field]} />
            </div>
        )
    }

    const statusBodyTemplate = (rowData, field) => {
        return <div
            style={{ display: 'flex', fontWeight: 'bolder', color: 'white', justifyContent: 'center', textAlign: 'center', alignItems: 'center', borderRadius: '6px', padding: '3px 10px', fontSize: '0.8rem', backgroundColor: getSeverity(rowData[field]) }}>
            {rowData[field]}
        </div>
    }

    const headerElement = (col, iconForm) => {
        if (col.Type !== 'boolean' && col.Type !== 'string' && col.Type !== 'int32' && col.Type !== 'datetime') {
            return (
                <div id='columnTable' title={col.Header} style={{ display: 'flex', cursor: 'pointer' }}>
                    <div id='columnTable' title={col.Header} style={{ marginRight: '10px' }}>
                        {col.NormalizedName}
                    </div>
                </div>
            )
        }
        return (
            <div onClick={(e) => order(e)} id='columnTable' title={col.Header} style={{ display: 'flex', cursor: 'pointer' }}>
                <div id='columnTable' title={col.Header} style={{ marginRight: '10px' }}>
                    {col.NormalizedName}
                </div>
                {iconForm === 'asc' ?
                    (<i id='columnTable' title={col.Header} className="pi pi-sort-amount-down "></i>) :
                    iconForm === 'desc' ?
                        (<i id='columnTable' title={col.Header} className="pi pi-sort-amount-up "></i>) :
                        iconForm === 'default' ?
                            (<i id='columnTable' title={col.Header} className="pi pi-sort-alt"></i>) :
                            (<i id='columnTable' title={col.Header} className="pi pi-sort-alt"></i>)
                }
            </div>
        )
    }

    //*definition of table columns
    const dynamicColumns = selectedColumns.map((col, i) => {
        let iconForm = 'default'
        if (orderInfo.columnName === col.Header) {
            if (orderInfo.orderbool === false) {
                iconForm = 'asc'
            }
            if (orderInfo.orderbool === true) {
                iconForm = 'desc'
            }
        } else {
            iconForm = 'default'
        }
        if (col.Type === 'boolean') {
            return (
                <Column
                    id='head'
                    key={i}
                    dataType={col.Type}
                    field={col.Name}
                    header={headerElement(col, iconForm)}
                    body={(data) => verifiedBodyTemplate(data, col.Name)}
                    headerStyle={{
                        borderBottom: `2px solid ${color}`,
                        color: secondColor
                    }}
                ></Column>
            )
        }
        if (col.NormalizedName == 'Status') {
            return (
                <Column
                    id='head'
                    key={i}
                    dataType={col.Type}
                    field={col.Name}
                    header={headerElement(col, iconForm)}
                    showAddButton={true}
                    body={(data) => statusBodyTemplate(data, col.Name)}
                    headerStyle={{
                        borderBottom: `2px solid ${color}`,
                        color: secondColor
                    }}
                ></Column>
            )
        }

        return (
            <Column
                id='head'
                key={i}
                dataType={col.Type}
                field={col.Name}
                header={headerElement(col, iconForm)}
                showAddButton={true}
                headerStyle={{
                    borderBottom: `2px solid ${color}`,
                    color: secondColor
                }}
            ></Column>
        )
    })

    const rebuildContextMenu = () => {
        const tempArray = []
        if (!removeItem.includes('View')) {
            tempArray.push({ label: t("view"), icon: (<i className='pi pi-search' style={{ color: color, marginRight: '0.5rem' }}></i>), command: replaceFunctions?.get('View') ? () => { replaceFunctions?.get('View')(selectContext) } : () => handleView(selectContext) })
        }
        if (permissions.includes('Edit') && !removeItem.includes('Edit')) {
            tempArray.push({ label: t("Edit"), icon: 'pi pi-pencil', command: replaceFunctions?.get('Edit') ? () => { replaceFunctions?.get('Edit')(selectContext) } : () => handleOpenEdit(selectContext) })
        }
        if (permissions.includes('Create') && !removeItem.includes('Create') && !removeItem.includes('Copy')) {
            tempArray.push({ label: t("Copy"), icon: 'pi pi-copy', command: replaceFunctions?.get('Copy') ? () => { replaceFunctions?.get('Copy')(selectContext) } : () => handleOpenCopy(selectContext) })
        }
        if (permissions.includes('Delete') && !removeItem.includes('Delete')) {
            tempArray.push({ label: t("Delete"), icon: 'pi pi-trash', command: replaceFunctions?.get('Delete') ? () => { replaceFunctions?.get('Delete')(selectContext) } : (obj, data) => constextDeleteButton(obj, data) })
        }
        tempArray.push(...contextMenu)
        if (permissions.includes('Audit') && !removeItem.includes('Audit')) {
            tempArray.push({ separator: true },)
            tempArray.push({ label: t("Audit"), icon: 'pi pi-search', command: () => getAudit(selectContext) })
        }
        return tempArray
    }

    const constextDeleteButton = (event, data) => {
        const tempObj = { ...selectContext }
        setDataContextMenu(tempObj)
        handleOpenDelete(selectContext)
    }

    //loadingBar div styles
    const defaultStyle = { position: 'absolute', overflow: 'hidden', height: '100%', width: '100%', zIndex: '5000000', backgroundColor: 'var(--color-grey-light)', opacity: '0.7' }
    const loadingStyle = { ...defaultStyle, height: '100vh' }
    const hideStyle = { ...defaultStyle, display: 'none' }
    const mainStyle = adjustingTableMedia2 ? { ...loadingStyle, top: '50px' } : { ...loadingStyle, top: '0px' }

    return (
        <>
            {isLoaded ? (<LoadingBar />) : (
                <div>
                    <ContextMenu model={columnContextMenu} onShow={e => cm.current.hide(e.originalEvent)} ref={ccm} />
                    <ContextMenu model={rebuildContextMenu()} onShow={e => ccm.current.hide(e.originalEvent)}
                        onHide={(e) => {
                            if (e && e.target.className !== 'p-menuitem-link') {
                                if (onPassContext) onPassContext(null)
                                sessionStorage.removeItem('contextLine')
                            }
                            setSelectContext(null)
                        }} ref={cm}
                    />
                    {isTable ?
                        <div className='secondDivDataTable' onContextMenu={(e) => { rightClick(e) }} >
                            <DataTable
                                className='defaultTable'
                                tableStyle={{ width: '100%' }}
                                header={header}
                                value={rows}
                                size="small"
                                selection={selectedRows}
                                selectionMode="multiple"
                                stripedRows
                                responsiveLayout="scroll"
                                breakpoint="960px"
                                scrollHeight={height}
                                reorderableColumns
                                ref={dt} //necessário para o export de CSV
                                onSelectionChange={onSelectionChange}
                                onContextMenuSelectionChange={e => {
                                    sessionStorage.setItem('contextLine', JSON.stringify(e.value))
                                    setSelectContext(e.value)
                                    if (onPassContext) onPassContext(e.value)
                                }}
                                onContextMenu={e => cm.current.show(e.originalEvent)}
                            >
                                {isSelectSingle ?
                                    <Column
                                        headerStyle={{
                                            borderBottom: `2px solid ${color}`,
                                            color: secondColor
                                        }}
                                        selectionMode="single" className='OpenTableCheckbox' frozen></Column>
                                    :
                                    <Column
                                        headerStyle={{
                                            borderBottom: `2px solid ${color}`,
                                            color: secondColor
                                        }}
                                        selectionMode="multiple" className='TableSelectionColumn' frozen></Column>
                                }
                                {dynamicColumns}
                            </DataTable>
                            <Paginator
                                className='paginator'
                                rows={pageSize}
                                totalRecords={totalRows} //* total pages
                                first={firstRows} //* current page
                                onPageChange={(e) => onPage(e)}
                            >
                            </Paginator>
                        </div>
                        :
                        <CrudTable
                            metaType={metaType}
                            entity={entity}
                            onGetWithFilters={getWithFilters}
                            onToastMessages={toastMessages}
                            operation={operation}
                            setIsTable={setIsTable}
                            rowEdit={rowEdit}
                            setRowEdit={setRowEdit}
                            valueAdd={valueAdd}
                            setValueAdd={setValueAdd}
                            isCopy={isCopy}
                            setIsCopy={setIsCopy}
                            editMap={editMap}
                            setEditMap={setEditMap}
                            row={row}
                            isChildTable={isChildTable}
                            parentLine={parentLine}
                            field={field}
                            companies={companies}
                            hasConfirmation={hasConfirmation}
                        />
                    }
                    <M_MessageBoard
                        warning
                        open={openConfirmDelete}
                        onClose={handleCloseConfirmDelete}
                        title={<div style={{ color: 'var(--color-red-dark)' }}>{t("Delete")} {t(entityName)} ?</div>}
                        body={
                            <span>
                                {t("TitleConfirmDelete")} <b>{entityName}</b>
                            </span>
                        }
                        footer={
                            <span style={{ display: 'flex' }}>
                                <M_Button
                                    normal
                                    hoverEffect
                                    label={t("ButtonCancel")}
                                    backgroundColor={'var(--color-white)'}
                                    borderColor={'var(--color-grey-dark2)'}
                                    labelColor={'var(--color-grey-dark2)'}
                                    onClick={handleCloseConfirmDelete}
                                />
                                <M_Button
                                    normal
                                    hoverEffect
                                    width={20}
                                    label={t("Delete")}
                                    backgroundColor={'var(--color-red)'}
                                    borderColor={'var(--color-red)'}
                                    labelColor={'var(--color-white)'}
                                    onClick={postDelete}
                                />
                            </span>
                        }
                    />
                    <M_MessageBoard
                        open={openAudit}
                        onClose={closeAudit}
                        minWidth={'80vw'}
                        maxWidth={!breakAuditWidth2 && '100vw'}
                        top={!breakAuditWidth && breakAuditWidth2 && '0'}
                        left={!breakAuditWidth && breakAuditWidth2 && '0'}
                        body={

                            <div style={{ height: '70vh', overflow: 'auto', width: '100%', }}>
                                <div style={{ width: '100%', height: '60vh', }}>
                                    <h1 style={{ display: 'flex', justifyContent: 'center' }}>{entityName} Audit</h1>
                                    {auditData?.sort((a, b) => Date.parse(a?.CreationDate) - Date.parse(b?.CreationDate))?.map((obj, index) => (
                                        <Accordion
                                            sx={{
                                                border: '1px solid var(--color-black)',
                                                borderRadius: '10px !important',
                                                marginBottom: '20px',
                                                scrollbarWidth: '0px'
                                            }}
                                            key={index}
                                        >
                                            <AccordionSummary
                                                expandIcon={<ArrowDownward />}
                                            >
                                                <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                    <div style={{ display: 'grid', gridTemplateColumns: !breakAuditWidth ? 'auto' : '33% 33% 33%', alignItems: 'center', width: '100%', marginBottom: '10px' }}>
                                                        <div style={{ display: 'flex' }}>
                                                            <div style={{ fontSize: '12px', marginRight: '10px', alignItems: 'center' }}>
                                                                {t("Action")}:
                                                            </div>
                                                            <div style={{ color: obj.Action == 'Create' ? 'var(--color-green)' : obj.Action == 'Update' ? 'var(--color-yellow)' : 'var(--color-black)', fontWeight: 'bolder' }}>
                                                                {obj.Action}
                                                            </div>
                                                        </div>
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <div style={{ fontSize: '12px', marginRight: '10px' }}>
                                                                {t("CreatedByEmail")}:
                                                            </div>
                                                            <div style={{
                                                                textOverflow: 'ellipsis',
                                                                overflow: 'hidden',
                                                                whiteSpace: 'wrap'
                                                            }}>
                                                                {obj.CreatedByEmail}
                                                            </div>
                                                        </div>
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <div style={{ fontSize: '12px', marginRight: '10px' }}>
                                                                {t("On")}:
                                                            </div>
                                                            <div >
                                                                {obj.CreationDate.replace('T', ' ').split('.')[0]}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </AccordionSummary>
                                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                <div style={{
                                                    width: '80%',
                                                    borderBottom: `2px solid var(--color-black)`,
                                                    marginBottom: '10px',
                                                }}></div>
                                            </div>
                                            {/* Render recursivo dos fields */}
                                            <RenderAuditFields fields={obj.AuditFields} />

                                        </Accordion>
                                    ))
                                    }
                                </div>
                                <div style={{ position: 'absolute', top: '20px', right: '20px' }}>
                                    <M_Button
                                        none
                                        icon={<CloseRounded style={{ color: 'var(--color-red)', scale: '1.5' }} color='var(--color-red)' />}
                                        onClick={closeAudit}
                                    />
                                </div>
                            </div >

                        }
                    />
                </div >
            )
            }
            <div style={loading ? mainStyle : hideStyle}>
                <LoadingBar />
            </div>
        </>
    )
}